import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false
})
export class AlertDialogComponent {
  data = inject<{
    message: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<AlertDialogComponent>>(MatDialogRef);

  message: string = '';


  constructor() {
    const data = this.data;

    this.message = data.message || this.message;
    this.dialogRef.disableClose = false;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
